import * as z from "zod/v4";

export const getUserFeatureFlag = {
  name: "getUserFeatureFlag" as const,
  input: z.object({ key: z.string() }),
  output: z.object({ enabled: z.boolean() }),
};
